import Guest from './Guest';
import Admin from './Admin';

export default {
  Guest,
  Admin
};
